<template>
    <v-container fluid class="pa-0">
        <!--get info-->
        <v-container class="my-4">
            <v-form v-model="valid" ref="form" validation>
                <v-row>
                    <v-col cols="12" sm="4" md="2">
                        <v-select dense color="secondary" item-color="secondary" return-object v-model="set"
                            :items="sets" item-text="item" item-value="value" label="set for game"
                            :rules="[rules.required]">
                        </v-select>
                    </v-col>
                    <v-col cols="12" sm="4" md="2">
                        <v-select dense color="secondary" item-color="secondary" return-object v-model.number="round"
                            :items="rounds" label="round" :rules="[rules.number]">
                        </v-select>
                    </v-col>
                    <v-col cols="12" sm="3" md="2" class="mt-4">
                        <v-btn color="secondary" small dark class="text-lowercase" :disabled="!valid || Boolean(error)"
                            @click="load">load
                        </v-btn>
                    </v-col>

                    <v-col v-if="valid && chainRout" cols="12" class="mt-4" sm="3" md="2">
                        <add-chain :set="set"></add-chain>
                    </v-col>
                    <v-col v-else-if="valid && afRout" cols="12" class="mt-4" sm="3" md="2">
                        <add-af :set="set" :round="round" />
                    </v-col>
                    <v-col v-else-if="valid && storiesRout" cols="12" class="mt-4" sm="3" md="2">
                        <add-commercial-story :set="set" :round="round" />
                    </v-col>
                    <v-col v-else-if="valid && insightsRout" cols="12" class="mt-4" sm="3" md="2">
                        <add-insight :set="set" :round="round" />
                    </v-col>
                    <v-col v-else-if="valid && mediaRout" cols="12" class="mt-4" sm="3" md="2">
                        <add-media :set="set" :round="round" />
                    </v-col>
                    <v-col v-else cols="12" class="mt-4" sm="3" md="2">
                        <add-segment :set="set" :round="round" />
                    </v-col>
                </v-row>
            </v-form>
        </v-container>
        <!--tabs-->
        <v-divider></v-divider>
        <v-tabs v-model="tab" height="35" background-color="primary" fixed-tabs hide-slider dark>
            <v-tab :to="link(item)" ripple class="text-capitalize" exact-active-class v-for="item in itemsTab"
                :key="item">
                {{ item }}
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item value="/admin/market/segments">
                <segments></segments>
            </v-tab-item>
            <v-tab-item value="/admin/market/habits">
                <consumer-habits />
            </v-tab-item>
            <v-tab-item value="/admin/market/design">
                <design />
            </v-tab-item>
            <v-tab-item value="/admin/market/materials">
                <materials />
            </v-tab-item>
            <v-tab-item value="/admin/market/values">
                <values />
            </v-tab-item>
            <!-- media -->
            <v-tab-item value="/admin/market/media">
                <media />
            </v-tab-item>
            <!--advanced features-->
            <v-tab-item value="/admin/market/features">
                <advanced-features />
            </v-tab-item>
            <!--commertial stories-->
            <v-tab-item value="/admin/market/stories">
                <commercial-story />
            </v-tab-item>
            <!--insights-->
            <v-tab-item value="/admin/market/insights">
                <insights />
            </v-tab-item>
            <v-tab-item value="/admin/market/chains">
                <chains></chains>
            </v-tab-item>
        </v-tabs-items>
    </v-container>
</template>
<script>
import Segments from './market/Segment.vue'
import ConsumerHabits from './market/ConsumerHabits.vue';
import Values from './market/Values.vue'
import Design from './market/Design.vue';
import Materials from './market/Materials.vue';
import Media from './market/Media.vue';
//import BrandAwarenessLoyalty from './market/BrandAwareness&Loyalty.vue';
import AdvancedFeatures from './market/AdvancedFeatures.vue';
import CommercialStory from './market/CommercialStory.vue';
import Insights from './market/Insights.vue';
import Chains from './market/Chains.vue';

import AddSegment from '../../components/admin/segments/addSegment.vue';
import AddAf from '../../components/admin/advanced-features/addFeature.vue'
import AddChain from '../../components/admin/chains/addChain.vue'
import addMedia from '../../components/admin/media/addMedia.vue';
//import AddAwareness from '../../components/admin/brand-awareness&loyalty/AddAwareness.vue';
//import AddLoyalty from '../../components/admin/brand-awareness&loyalty/AddLoyalty.vue';
import AddCommercialStory from '../../components/admin/commercial-story/addCommercialStory.vue';
import AddInsight from '../../components/admin/insights/addInsight.vue';

export default {
    data() {
        return {
            itemsTab: [
                'Segments',
                'Consumer habits',
                'Design', 'Materials',
                'Values', 'Media',
                'Advanced features',
                'Commercial stories',
                'Insights', 'Chains'],
            tab: 0,
            valid: false,
            error: '',
            rules: {
                required: value => !!value || 'required field',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number'
            },
            
            set: { item: 'standart', value: 2 },
            round: 0,
        }
    },
    computed: {
        user() {
            return this.$store.getters.user;
        },
        games() {
            return this.$store.getters.games;
        },
        //routes
        chainRout() {
            return /\/market\/chains/.test(this.$route.path)
        },
        insightsRout() {
            return /\/market\/insights/.test(this.$route.path)
        },
        storiesRout() {
            return /\/market\/stories/.test(this.$route.path)
        },
        afRout() {
            return /\/market\/features/.test(this.$route.path)
        },
        mediaRout() {
            return /\/market\/media/.test(this.$route.path)
        },
        sets() {
            const fixed_arr = [
                { item: 'simple', value: 1 },
                { item: 'standart', value: 2 },
                { item: 'advanced', value: 3 }
            ]

            const custom_arr = this.games.filter(game => game.id > 3)
            if (custom_arr.length > 0) {
                custom_arr.map(item => {
                    fixed_arr.push({
                        item: `${item.category}_${item.id}`,
                        value: item.id
                    })
                })
            }

            return fixed_arr;
        },
        rounds() {
            const fixed_arr = [0];
            if (this.set.value > 3) {
                const currentGame = this.games.find(game => game.id == this.set.value);
                if (currentGame && currentGame.round > 0) {
                    for(let i = 1; i <= currentGame.round; i++) {
                        fixed_arr.push(i)
                    }
                }
            }
            //console.log(fixed_arr);
            return fixed_arr;
        }
    },
    methods: {
        link(name) {
            const arr = name.split(' ');
            if (arr.length > 1) {
                return `/admin/market/${arr[1].toLowerCase()}`
            }
            return `/admin/market/${name.toLowerCase()}`
        },
        async load() {
            let gameId = this.set.value;
            let round = this.round;
            const obj = {
                gameId: gameId,
                round: round
            }
            const category = this.set.item.split('_')[0];
            //console.log(category)
            try {
                if (this.chainRout) {
                    await this.$store.dispatch('fetchChains', gameId);
                }
                else if (this.afRout) {
                    await this.$store.dispatch('fetchAdvancedFeatures', obj);
                }
                else if (this.storiesRout) {
                    await this.$store.dispatch('fetchCommercialStories', category);
                }
                else if (this.insightsRout) {
                    await this.$store.dispatch('fetchInsights', obj);
                }
                /* else if (this.brandRout) {
                    await this.$store.dispatch('fetchAwareness', obj);
                    await this.$store.dispatch('fetchLoyalty', obj);
                } */
                else if (this.mediaRout) {
                    await this.$store.dispatch('fetchMedia', obj);               }
                else {
                   await this.$store.dispatch('fetchMarketSegments', obj); 
                }
            }
            catch (err) {
                console.log(err)
            }
        },
    },
    components: {
        Segments, Values, Design, Materials, AdvancedFeatures, 
        Chains, Media, ConsumerHabits,
        CommercialStory,Insights,
        AddSegment, AddChain, AddAf, addMedia,
        AddCommercialStory, AddInsight,
    },
    async mounted() {
        if (!this.games.length) {
            try {
                await this.$store.dispatch('fetchAllGames');
            }
            catch (error) {
                console.log(error.message)
            }
        }
    }

}
</script>
